import {formatRevenueNumber, formatSizeNumber} from "helpers/string";
import React from "react";
import styles from "./statistics.module.scss";

export default function Statistics({revenue, size}: {revenue: number; size: number}) {
	return (
		<span className={styles.statisticsWrapper}>
			{revenue > 0 && (
				<div className={styles.indexStat}>
					<svg
						width="20"
						height="20"
						viewBox="0 0 20 20"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<mask
							id="mask0_4776_11811"
							style={{maskType: "alpha"}}
							maskUnits="userSpaceOnUse"
							x="0"
							y="0"
							width="20"
							height="20"
						>
							<rect width="20" height="20" fill="#D9D9D9" />
						</mask>
						<g mask="url(#mask0_4776_11811)">
							<path
								d="M9.29167 15.5H10.6875V14.5208C11.3681 14.4097 11.9306 14.1181 12.375 13.6458C12.8194 13.1736 13.0417 12.625 13.0417 12C13.0417 11.375 12.8507 10.8403 12.4688 10.3958C12.0868 9.95139 11.5 9.58333 10.7083 9.29167C9.86111 8.98611 9.30208 8.72569 9.03125 8.51042C8.76042 8.29514 8.625 8.01389 8.625 7.66667C8.625 7.38889 8.74653 7.15972 8.98958 6.97917C9.23264 6.79861 9.54861 6.70833 9.9375 6.70833C10.3264 6.70833 10.6667 6.80208 10.9583 6.98958C11.25 7.17708 11.4444 7.43056 11.5417 7.75L12.7708 7.22917C12.6042 6.77083 12.3368 6.38542 11.9688 6.07292C11.6007 5.76042 11.1736 5.5625 10.6875 5.47917V4.5H9.3125V5.5C8.6875 5.63889 8.1875 5.90625 7.8125 6.30208C7.4375 6.69792 7.25 7.15972 7.25 7.6875C7.25 8.3125 7.46181 8.84375 7.88542 9.28125C8.30903 9.71875 8.97917 10.0972 9.89583 10.4167C10.5208 10.6389 10.9757 10.875 11.2604 11.125C11.5451 11.375 11.6875 11.6667 11.6875 12C11.6875 12.3611 11.5417 12.6632 11.25 12.9062C10.9583 13.1493 10.5972 13.2708 10.1667 13.2708C9.70833 13.2708 9.30208 13.1181 8.94792 12.8125C8.59375 12.5069 8.35417 12.1111 8.22917 11.625L6.9375 12.1667C7.10417 12.75 7.39583 13.2465 7.8125 13.6562C8.22917 14.066 8.72222 14.3472 9.29167 14.5V15.5ZM10 18C8.90278 18 7.86806 17.7917 6.89583 17.375C5.92361 16.9583 5.07292 16.3854 4.34375 15.6562C3.61458 14.9271 3.04167 14.0764 2.625 13.1042C2.20833 12.1319 2 11.0972 2 10C2 8.88889 2.20833 7.85069 2.625 6.88542C3.04167 5.92014 3.61458 5.07292 4.34375 4.34375C5.07292 3.61458 5.92361 3.04167 6.89583 2.625C7.86806 2.20833 8.90278 2 10 2C11.1111 2 12.1493 2.20833 13.1146 2.625C14.0799 3.04167 14.9271 3.61458 15.6562 4.34375C16.3854 5.07292 16.9583 5.92014 17.375 6.88542C17.7917 7.85069 18 8.88889 18 10C18 11.0972 17.7917 12.1319 17.375 13.1042C16.9583 14.0764 16.3854 14.9271 15.6562 15.6562C14.9271 16.3854 14.0799 16.9583 13.1146 17.375C12.1493 17.7917 11.1111 18 10 18ZM10 16.5C11.8056 16.5 13.3403 15.8681 14.6042 14.6042C15.8681 13.3403 16.5 11.8056 16.5 10C16.5 8.19444 15.8681 6.65972 14.6042 5.39583C13.3403 4.13194 11.8056 3.5 10 3.5C8.19444 3.5 6.65972 4.13194 5.39583 5.39583C4.13194 6.65972 3.5 8.19444 3.5 10C3.5 11.8056 4.13194 13.3403 5.39583 14.6042C6.65972 15.8681 8.19444 16.5 10 16.5Z"
								fill="#2C3030"
							/>
						</g>
					</svg>

					<span className={styles.indexTitle}>{formatRevenueNumber(revenue)}</span>
				</div>
			)}

			{size > 0 && (
				<div className={styles.employeeStat}>
					<svg
						width="20"
						height="20"
						viewBox="0 0 20 20"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<mask
							id="mask0_4776_11816"
							style={{maskType: "alpha"}}
							maskUnits="userSpaceOnUse"
							x="0"
							y="0"
							width="20"
							height="20"
						>
							<rect width="20" height="20" fill="#D9D9D9" />
						</mask>
						<g mask="url(#mask0_4776_11816)">
							<path
								d="M10 10C9.16667 10 8.45833 9.70833 7.875 9.125C7.29167 8.54167 7 7.83333 7 7C7 6.16667 7.29167 5.45833 7.875 4.875C8.45833 4.29167 9.16667 4 10 4C10.8333 4 11.5417 4.29167 12.125 4.875C12.7083 5.45833 13 6.16667 13 7C13 7.83333 12.7083 8.54167 12.125 9.125C11.5417 9.70833 10.8333 10 10 10ZM4 16V14C4 13.6806 4.08681 13.3785 4.26042 13.0938C4.43403 12.809 4.67361 12.5694 4.97917 12.375C5.74306 11.9306 6.55064 11.5903 7.40192 11.3542C8.25321 11.1181 9.11779 11 9.99567 11C10.8736 11 11.7396 11.1181 12.5938 11.3542C13.4479 11.5903 14.2569 11.9306 15.0208 12.375C15.3264 12.5556 15.566 12.7917 15.7396 13.0833C15.9132 13.375 16 13.6806 16 14V16H4ZM5.5 14.5H14.5V14C14.5 13.9281 14.479 13.8628 14.437 13.8039C14.395 13.7451 14.3396 13.6993 14.2708 13.6667C13.6319 13.2778 12.9514 12.9861 12.2292 12.7917C11.5069 12.5972 10.7639 12.5 10 12.5C9.23611 12.5 8.49306 12.5972 7.77083 12.7917C7.04861 12.9861 6.36806 13.2778 5.72917 13.6667C5.65972 13.7222 5.60417 13.7759 5.5625 13.8276C5.52083 13.8793 5.5 13.9368 5.5 14V14.5ZM10.0044 8.5C10.4181 8.5 10.7708 8.35269 11.0625 8.05808C11.3542 7.76346 11.5 7.40929 11.5 6.99558C11.5 6.58186 11.3527 6.22917 11.0581 5.9375C10.7635 5.64583 10.4093 5.5 9.99558 5.5C9.58186 5.5 9.22917 5.64731 8.9375 5.94192C8.64583 6.23654 8.5 6.59071 8.5 7.00442C8.5 7.41814 8.64731 7.77083 8.94192 8.0625C9.23654 8.35417 9.59071 8.5 10.0044 8.5Z"
								fill="#2C3030"
							/>
						</g>
					</svg>

					<span className={styles.employeeTitle}>{formatSizeNumber(size)}</span>
				</div>
			)}
		</span>
	);
}
